// create regex for length > 20 and < 1000
export const descriptionRegex = new RegExp("^[\\s\\S]{20,1000}$");
// create regex for email
export const emailRegex = new RegExp(
  "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$"
);
//create regex for name
export const nameRegex = new RegExp("^[a-zA-Z ]{2,30}$");
//create regex for userName
export const userNameRegex = new RegExp("^[a-zA-Z0-9]{2,30}$");
//create regex for password
export const passwordRegex = new RegExp(
  "^(?=.*d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*s).{8,100}$"
);
//create regex for alphaNumeric name
export const alphaNumericRegex = new RegExp("^[a-zA-Z0-9 ]{2,30}$");

//create regex for url of a video
//regex for anything
export const videoUrlRegex = new RegExp("^(http(s)?:\\/\\/)?((w){3}.)?.+");
